import { render, staticRenderFns } from "./gerenDetail.vue?vue&type=template&id=8052dd74&scoped=true&"
import script from "./gerenDetail.vue?vue&type=script&lang=js&"
export * from "./gerenDetail.vue?vue&type=script&lang=js&"
import style0 from "./gerenDetail.vue?vue&type=style&index=0&id=8052dd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8052dd74",
  null
  
)

export default component.exports